var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.role !== 'admin' && (_vm.notForRoles == null || _vm.notForRoles.includes(_vm.role)))?_c('div',{staticClass:"black"}):_c('div',[_c('NextSceneButton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }